// column.js
const column = {
    state: {
        searchList: null
    },
    mutations: {
        SET_SEARCHLIST(state, data) {
            state.searchList = data;
        }
    },
    actions: {
        setSearchList({ commit }, data) {
            commit('SET_SEARCHLIST', data);
        }
    },
    getters: {
        // 模块A的getters
    }
};

export default column;